namespace advisorop.components.servicer {

    class SelectCuCompanyGroupServicerController {
        $router;
        selectedCompanyGroup: domains.ICompanyGroup;
        isCompanyGroupSelected: boolean = false;
        onSelectedCompanyGroup: any;
        accounts: any;
        showLabel: string = "false";

        static $inject = ["identityService", "servicerService"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {
        }

        responseDataSearch: Array<domains.CompanyGroup> = [];
        searchCompanyGroup(searchTerm: string): ng.IPromise<{}> {

            return this.servicerService.searchCompanyGroupByName(searchTerm)
                .then((response) => {
                        return <Array<domains.CompanyGroup>>response.data;
                });
        }

      

        onSelectCompanyGroup(item, model, label, event): void {
            //console.log("comp gr id");
            //console.log(this.companyGroupId);
            this.isCompanyGroupSelected = true;
            this.onSelectedCompanyGroup({ companyGroup: item });
           
        //    this.selectedCompanyGroup = {};
            //this.selectedCompanyGroup = item;
            //this.loadUnmappedAccounts();
        }


        clearSelectedCompanyGroup(): void {
            this.selectedCompanyGroup = null;
            this.isCompanyGroupSelected = false;
            //this.companyGroupId = 0;
            this.onSelectedCompanyGroup({ companyGroup: null });
            this.showLabel = 'false';
        }

        loadUnmappedAccounts(): void {
            var rez = this.servicerService.getUnmappedAccounts(this.selectedCompanyGroup.ppFirmId);

            rez.then((data) => {
                this.accounts = data.data;
            }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };

        loadCompanyGroupById(companyGroupId: number): void {
            this.servicerService.getCompanyGroup(companyGroupId)
                .then(data => {
                    this.selectedCompanyGroup = data.data;

                    this.flag = true;
                    this.showLabel = "true";

                    this.onSelectedCompanyGroup({ companyGroup: this.selectedCompanyGroup });

                })
                .catch(err => { toastr.error("Unable to fetch company group!"); })
        }

        companyGroupId: number;

        $onInit(): void {
        }

        flag: boolean = false;

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "companyGroupId") {
                    if (this.companyGroupId > 0) {
                        this.loadCompanyGroupById(this.companyGroupId);
                    }
                }
                //if (key === "showLabel") {
                //    if (this.companyGroupId > 0) {
                //        this.showLabel = 'true';
                //        this.flag = true;
                //    }
                //    else {
                //        this.showLabel = 'false';
                //        this.flag = false;
                //    }
                //}
               
            }
        }


        $routerOnActivate(next, previous) {
        }


    }


    class SelectCuCompanyGroupServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": '<',
                onSelectedCompanyGroup: '&',
                companyGroupId: "<",
                showLabel: "@"
            };
            this.controller = SelectCuCompanyGroupServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/select-cu-company-group-servicer.html';
        }
    }
    angular.module(Constants.APP).component("selectCuCompanyGroupServicer", new SelectCuCompanyGroupServicer());


}